import { SettingsProvider, SettingType } from '@fluidx/office-fluid-types';
import { getFluidExperiencesSetting } from '@fluidx/utilities';

let settingsProvider: SettingsProvider;

/**
 * Contains the settings names available in office-web-host.
 */
export enum OfficeWebHostSetting {
  externalRequest = 'owhSetting.externalRequest'
}

/**
 * Registers the setting provider provided by the host.
 */
export function registerSettingsProvider(hostSettingsProvider: SettingsProvider): void {
  settingsProvider = hostSettingsProvider;
}

/**
 * Returns the value of the requested setting from office-web-host layer.
 * It uses the `SettingProvider` from the `scope` object.
 * @param settingName requested setting
 * @param defaultValue default value of the setting in case it's missing
 */
export function getOWHSetting<T extends SettingType>(settingName: OfficeWebHostSetting, defaultValue: T): T {
  return getFluidExperiencesSetting<T>(settingName, defaultValue, settingsProvider);
}
